function toNumber(value) {
  try {
    return Number(value.replace(",", "."));
  } catch (e) {
    return 0;
  }
}

function formatNumber(number) {
  return Math.abs(Number(number))
    .toFixed(2)
    .replace(".", ",");
}

export default class Sped {
  constructor(lines) {
    this.lines = lines;
  }

  setRetificacao() {
    const line = this.lines[0].split("|");
    line[3] = 1;
    this.lines[0] = line.join("|");
  }

  ajustaC197() {
    this.setRetificacao();

    const allowedCfops = [
      "1101030",
      "1102030",
      "1126002",
      "1126006",
      "1126008",
      "1401001",
      "1401002",
      "1401004",
      "1401006",
      "1401030",
      "1653002",
      "1653003",
      "1653004",
      "1949055",
      "2101030",
      "2126002",
      "2126006",
      "2126008",
      "2128002",
      "2401002",
      "2401004",
      "2401006",
      "2403002",
      "2653002",
      "2653003",
      "2653004",
      "2949055",
      "1653001",
      "1653000",

      // CFOPS Temporarias
      // '1202001',
      // '2202001',
    ];
    const rootCfop = allowedCfops.map((c) => c.substr(0, 4));
    // Init variables

    let c100 = null;
    let iC100 = 0;
    let bcIcmsC100 = 0;
    let vIcmsC100 = 0;

    let totalBcIcms = 0;
    let totalVIcms = 0;

    let reg0460Criado = !!this.lines.find((l) => l === "|0460|20|ICMS Substituição Tributária|");
    let create0460AtLine = null;

    let c170 = [];
    let c190 = [];
    let lastC190 = null;
    let c195 = null;
    let c197 = null;
    let newLines = [];
    let lastLine = 0;

    for (let i = 0, l = this.lines.length; i < l; i++) {
      const line = this.lines[i];

      if (!reg0460Criado && line.startsWith("|0460|")) {
        create0460AtLine = newLines.length;
      }

      function processaC100() {
        if (c100 && c170.length) {
          let bcIcms = 0;
          let vIcms = 0;
          let aliquota = 0;
          c170.forEach((data) => {
            const { r, i } = data;
            const pBcIcms = toNumber(r[13]);
            const pVlIcms = toNumber(r[15]);
            const vIpi = toNumber(r[24]);
            aliquota = r[14].toString();
            const cst = r[10];
            const cfop = r[11];

            const c190Al = c190.find(({ c }) => cst === c[2] && cfop === c[3] && aliquota === c[4]);
            let c190Zero = c190.find(({ c }) => cst === c[2] && cfop === c[3] && "0" === c[4]);

            if (!c190Zero) {
              const c = ["", "C190", cst, cfop, "0", "0", "0", "0", "0", "0", "0", "0", "", ""];
              c190Zero = {
                c,
                j: lastC190 + 1,
              };
              c190.push(c190Zero);
              lastC190 = c190Zero.j;
              newLines.splice(c190Zero.j, 0, c.join("|"));
            }

            // Remove valor do C190 com Aliquota
            c190Al.c[5] = formatNumber(toNumber(c190Al.c[5]) - toNumber(r[7]) + toNumber(r[8]));
            c190Al.c[6] = formatNumber(toNumber(c190Al.c[6]) - pBcIcms);
            c190Al.c[7] = formatNumber(toNumber(c190Al.c[7]) - pVlIcms);
            c190Al.c[11] = formatNumber(toNumber(c190Al.c[11]) - vIpi);
            newLines[c190Al.j] = c190Al.c.join("|");

            //Adiciona valor para C190 com Aliquota 0
            c190Zero.c[5] = formatNumber(toNumber(c190Zero.c[5]) + toNumber(r[7]) - toNumber(r[8]));
            c190Zero.c[6] = formatNumber(0);
            c190Zero.c[7] = formatNumber(0);
            c190Zero.c[11] = formatNumber(toNumber(c190Zero.c[11]) + vIpi);
            newLines[c190Zero.j] = c190Zero.c.join("|");

            if (!toNumber(c190Al.c[6]) > 0 && c190Zero.j !== c190Al.j) {
              c190Zero.c[5] = formatNumber(toNumber(c190Zero.c[5]) + toNumber(c190Al.c[5]));
              c190Zero.c[11] = formatNumber(toNumber(c190Zero.c[11]) + toNumber(c190Al.c[11]));

              newLines[c190Zero.j] = c190Zero.c.join("|");
              newLines[c190Al.j] = "";
            }

            bcIcms += pBcIcms;
            vIcms += pVlIcms;

            r[13] = "0,00";
            r[14] = "0";
            r[15] = "0,00";

            newLines[i] = r.join("|");
          });

          c100[21] = formatNumber(bcIcmsC100 - bcIcms);
          c100[22] = formatNumber(vIcmsC100 - vIcms);

          totalBcIcms += bcIcms;
          totalVIcms += vIcms;

          if (bcIcms > 0) {
            const regC195 = [, "C195", "20", "", ""];
            newLines.push(regC195.join("|"));

            const regC197 = [
              ,
              "C197",
              "SC00000001",
              "",
              "",
              formatNumber(bcIcms),
              aliquota,
              formatNumber(vIcms),
              "0",
              "",
            ];
            newLines.push(regC197.join("|"));
          }

          newLines[iC100] = c100.join("|");
        }

        // limpa referencias do registro anterior
        c170 = [];
        c190 = [];
        lastC190 = null;
        c195 = null;
        c197 = null;
      }

      if (line.startsWith("|C100|")) {
        // Quando chega em um novo registro C100 preenche os registro C195 e C197 do registro C100 anterior
        processaC100();

        iC100 = newLines.length;
        c100 = line.split("|");
        bcIcmsC100 = toNumber(c100[21]);
        vIcmsC100 = toNumber(c100[22]);
      } else if (line.startsWith("|C170|")) {
        const r = line.split("|");
        if (allowedCfops.includes(r[12].replace(/[^0-9]/g, ""))) {
          c170.push({ r, i: newLines.length });
        }
      } else if (line.startsWith("|C190|")) {
        const c = line.split("|");
        if (rootCfop.includes(c[3])) {
          c190.push({ c, j: newLines.length });
        }
        lastC190 = newLines.length;
      } else if (line.startsWith("|C195|")) {
        c195 = line.split("|");
      } else if (line.startsWith("|C197|")) {
        c197 = line.split("|");
      } else if (line.startsWith("|C990|") || line.startsWith("|C500|")) {
        processaC100();
      }

      newLines.push(line);

      // Fechamento SPED
      if (line.startsWith("|C990|")) {
        const c990 = line.split("|");
        c990[2] = newLines.filter((l) => l.startsWith("|C")).length;
        newLines[newLines.length - 1] = c990.join("|");
      } else if (line.startsWith("|E110|")) {
        const r = line.split("|");
        r[6] = formatNumber(toNumber(r[6]) - totalVIcms);
        r[7] = formatNumber(toNumber(r[7]) + totalVIcms);
        newLines[newLines.length - 1] = r.join("|");
      } else if (line.startsWith("|0990|")) {
        // Cria registro 0460
        const shouldCreate =
          this.lines.filter((l) => {
            if (l.startsWith("|C170|")) {
              const r = l.split("|");
              const pBcIcms = toNumber(r[13]);
              if (allowedCfops.includes(r[12].replace(/[^0-9]/g, "")) && pBcIcms > 0) {
                return true;
              }
            }
            return false;
          }).length > 0;

        if (!reg0460Criado && shouldCreate) {
          if (!create0460AtLine) {
            newLines.forEach((line, idx) => {
              if (line.startsWith("|0400|")) {
                create0460AtLine = idx;
              }
              if (line.startsWith("|0450|")) {
                create0460AtLine = idx;
              }
            });
          }
          newLines.splice(create0460AtLine + 1, 0, "|0460|20|ICMS Substituição Tributária|");
          reg0460Criado = true;
        }
        const r = line.split("|");
        r[2] = newLines.filter((l) => l.startsWith("|0")).length;
        newLines[newLines.length - 1] = r.join("|");
      } else if (line.startsWith("|9900|0460|")) {
        const r = line.split("|");
        r[3] = newLines.filter((l) => l.startsWith("|0460|")).length;
        newLines[newLines.length - 1] = r.join("|");
      } else if (line.startsWith("|9900|C190|")) {
        const r = line.split("|");
        r[3] = newLines.filter((l) => l.startsWith("|C190|")).length;
        newLines[newLines.length - 1] = r.join("|");
      } else if (line.startsWith("|9900|C195|")) {
        const r = line.split("|");
        r[3] = newLines.filter((l) => l.startsWith("|C195|")).length;
        newLines[newLines.length - 1] = r.join("|");
      } else if (line.startsWith("|9900|C197|")) {
        const r = line.split("|");
        r[3] = newLines.filter((l) => l.startsWith("|C197|")).length;
        newLines[newLines.length - 1] = r.join("|");
      } else if (line.startsWith("|9999|")) {
        totalizaRegistro(newLines, "0460", "0450", "0400");
        totalizaRegistro(newLines, "C195", "C190");
        totalizaRegistro(newLines, "C197", "C195");

        newLines.forEach((l, idx) => {
          if (l.startsWith("|9900|9900|")) {
            newLines[idx] = `|9900|9900|${newLines.filter((l) => l.startsWith("|9900|")).length}|`;
          } else if (l.startsWith("|9990|")) {
            newLines[idx] = `|9990|${newLines.filter((l) => l.startsWith("|9")).length}|`;
          }
        });

        newLines = newLines.filter(Boolean);
        const r = [, "9999", newLines.length, ""];
        lastLine = newLines.length;
        newLines[lastLine - 1] = r.join("|");
      }
    }

    this.lines = newLines.slice(0, lastLine);
  }

  getSped() {
    return this.lines.join("\r\n") + "\r\n";
  }
}

function totalizaRegistro(newLines, registro, prevRegistro, prevRegistroOpt) {
  let regLine;
  let createAtLine;
  newLines.forEach((l, idx) => {
    if (l.startsWith(`|9900|${registro}|`)) {
      regLine = idx;
    }
    if (l.startsWith(`|9900|${prevRegistro}|`)) {
      createAtLine = idx + 1;
    }
    if (prevRegistroOpt && l.startsWith(`|9900|${prevRegistroOpt}|`)) {
      createAtLine = idx + 1;
    }
  });
  if (!regLine) {
    newLines.splice(
      createAtLine,
      0,
      `|9900|${registro}|${newLines.filter((l) => l.startsWith(`|${registro}|`)).length}|`,
    );
  }
}
